import React, { useContext, useEffect, useMemo } from 'react';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { Alert } from '@one-thd/sui-atomic-components';
import { Breadcrumbs } from '@thd-olt-component-react/breadcrumbs';
import { QueryProvider, extend } from '@thd-nucleus/data-sources';
import { CustomerAccountNavigation, useAccountCrumbs, } from '@thd-olt-component-react/customer-account-navigation';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { AddManageUsersContent } from '../components/add-manage-users-content/add-manage-users-content';
import { useInterceptors } from '../hooks/use-interceptors';
import { PageTitle } from '../components/shared/page-title/page-title';
import { AddManageUsersProvider } from '../contexts/add-manage-users-context';
import { DrawerProvider } from '../contexts/drawer-context';
import { mapCrumbsToStaticCrumbs, } from '../utils/breadcrumbs';
var crumbs = [
    {
        label: 'Add/Manage Users',
    },
];
var AddManageUsersPageContent = function () {
    var redirectError = useInterceptors().redirectError;
    var isConsumerApp = useContext(ExperienceContext).isConsumerApp;
    var staticCrumbs = mapCrumbsToStaticCrumbs(useAccountCrumbs(crumbs));
    return (React.createElement("div", { className: "grid isBound" },
        React.createElement("div", { className: "col__12-12" }, redirectError ? (React.createElement("div", { className: "sui-pt-8" },
            React.createElement(Alert, { status: "info" }, redirectError.message))) : (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "sui-grid sui-gap-3 sui-py-3" },
                !isConsumerApp && (React.createElement(ErrorBoundary, { name: "breadcrumbs" },
                    React.createElement(Breadcrumbs, { staticCrumbs: staticCrumbs }))),
                React.createElement(PageTitle, { title: "Add/Manage Users", dataTestId: "add-manager-users-title" })),
            React.createElement("div", { className: "sui-grid sui-grid-cols-12 sui-gap-5 sui-py-3" },
                React.createElement("div", { className: "sui-col-span-12 lg:sui-col-span-3" },
                    React.createElement(ErrorBoundary, { name: "customer-account-navigation" },
                        React.createElement(CustomerAccountNavigation, null))),
                React.createElement("div", { className: "sui-col-span-12 lg:sui-col-span-9" },
                    React.createElement(ErrorBoundary, { name: "add-manage-users" },
                        React.createElement(AddManageUsersProvider, null,
                            React.createElement(DrawerProvider, null,
                                React.createElement(AddManageUsersContent, null)))))))))));
};
AddManageUsersPageContent.dataModel = extend(CustomerAccountNavigation, AddManageUsersProvider, Breadcrumbs);
export var AddManageUsersPage = function (_a) {
    var isB2B = _a.isB2B, userId = _a.userId, svocId = _a.svocId;
    var isLoggedInAsB2C = useMemo(function () {
        return svocId && userId && !isB2B;
    }, [isB2B, svocId, userId]);
    useEffect(function () {
        if (isLoggedInAsB2C) {
            window.location.replace('/');
        }
    }, [isLoggedInAsB2C]);
    return (React.createElement(React.Fragment, null, !isLoggedInAsB2C && (React.createElement(QueryProvider, { cacheKey: "add-manage-users", defaultVariables: {
            channelId: 1,
            userId: userId,
            customerAccountId: svocId,
        } },
        React.createElement(AddManageUsersPageContent, null)))));
};
AddManageUsersPage.displayName = 'AddManageUsersPage';
